export default "__VITE_ASSET__CLRThdSJ__"